// Tokens de marca Ona Pulse — espejo de docs/05-diseno-marca.md
export const C = {
  bg: '#071C2B',
  bg2: '#0A2438',
  card: '#0D2B40',
  card2: '#123350',
  line: 'rgba(140,200,215,0.13)',
  ink: '#EAF4F6',
  muted: '#8CA9B8',
  faint: '#5E7B8C',
  aqua: '#1ED3C7',
  aquaDeep: '#10B3A9',
  aquaSoft: '#8FF2E7',
  chip: '#E3F8F6',
  gold: '#F5C34B',
  warn: '#F5B84B',
  orange: '#F0885E',
  bad: '#F87171',
  badDeep: '#E1554F',
  good: '#34D399',
};

export const F = {
  // Fredoka = voz de marca (wordmark, saludos, cifras héroe) · Sora = UI
  display: 'Fredoka_600SemiBold',
  displayMed: 'Fredoka_500Medium',
  ui: 'Sora_400Regular',
  uiMed: 'Sora_500Medium',
  uiSemi: 'Sora_600SemiBold',
  uiBold: 'Sora_700Bold',
  uiXBold: 'Sora_800ExtraBold',
};

export const R = { pill: 24, card: 20, sheet: 28, cell: 16 };

// Rampa secuencial de ocupación (oscuro→claro) + rojo reservado a overbooking
export const HEAT_RAMP = ['#0C2E3E', '#11555C', '#14807D', '#19AB9F', '#1ED3C7', '#8FF2E7'];
export const heatColor = (v: number) =>
  v > 100 ? C.bad : HEAT_RAMP[v < 70 ? 0 : v < 78 ? 1 : v < 85 ? 2 : v < 92 ? 3 : v < 98 ? 4 : 5];

/* 🔴 RAMPA DEL PRESUPUESTO — hermana de HEAT_RAMP, pero NO la misma función.
   Patricio, 26-08: «en vez de amarillo yo iría haciendo un degradé de color del
   logo, donde el más intenso es el 100 %».

   Es la regla de dataviz de la casa aplicada donde toca: una magnitud se pinta con
   una rampa secuencial de un solo tono (docs/05). Nueve barras amarillas idénticas
   no dejaban comparar de un vistazo; con la rampa, el ojo ordena la lista solo.

   🔴 Y NO se puede reusar `heatColor`: esa manda el ROJO por encima de 100, porque
   en ocupación pasarse es overbooking. Aquí pasarse del presupuesto es lo que se
   quiere, así que el 100 % es el color MÁS intenso de la marca (`#1ED3C7`) y de ahí
   no sube. Mismo idioma visual, doctrina contraria: por eso son dos funciones. */
/* 🔴 Corregida el 26-08 tras verla en pantalla: los cuatro tonos altos eran casi
   iguales y «el degradé casi no se nota» (Patricio). Y el tope pasa a ser EL
   CLARO (`aquaSoft`), no el intenso: es el mismo idioma que la rejilla de
   ocupación, donde lleno = clarito brillante — dos rampas de la casa con
   doctrinas opuestas confundirían más que ayudar. */
export const BUDGET_RAMP = ['#0E3E48', '#127572', '#18A89D', '#1ED3C7', '#8FF2E7'];
export const budgetColor = (pct: number) =>
  BUDGET_RAMP[pct >= 100 ? 4 : pct >= 92 ? 3 : pct >= 80 ? 2 : pct >= 60 ? 1 : 0];

// Severidad del ageing (progresión con etiquetas directas obligatorias)
export const AGEING_COLORS = [C.aqua, C.gold, C.orange, C.badDeep];

export const PMS_BADGE: Record<string, { bg: string; fg: string }> = {
  noray: { bg: 'rgba(30,211,199,0.13)', fg: C.aqua },
  avalon: { bg: 'rgba(167,139,250,0.15)', fg: '#B9A5F8' },
  navision: { bg: 'rgba(91,155,213,0.16)', fg: '#7FB4E8' },
  onasystem: { bg: 'rgba(245,195,75,0.14)', fg: C.gold },
};
